import React from 'react';
import { RouterProvider } from 'react-router-dom';
import appRoutes from './app_routes';
import authRoutes from './auth_routes';
import { useSelector } from 'react-redux';
import { StoreState } from '../../store/reducer-main';
import purchaseRoutes from './purchase_routes';
import { UserMemberShipStatus } from '../../types/profile';
import processingPaymentRoutes from './processing_payment_routes';
import { ProcessingPaymentState } from '../../enums/processingPayments';
import paymentSuccessRoutes from './payment_success_routes';
import paymentFailedRoutes from './paymentFailedRoutes';

export default function NavigationHandler() {

  const { userProfile } = useSelector((state: StoreState) => state.profile);
  const { state: processingPaymentState } = useSelector((state: StoreState) => state.processingPayments);

  const router = React.useMemo(() => {
    if (!userProfile) return authRoutes;
    if (processingPaymentState === ProcessingPaymentState.PENDING) return processingPaymentRoutes;
    if (processingPaymentState === ProcessingPaymentState.SUCCEEDED) return paymentSuccessRoutes;
    if (processingPaymentState === ProcessingPaymentState.FAILED) return paymentFailedRoutes;
    if (userProfile.membership) return appRoutes;
    return purchaseRoutes; // autenticato senza membership
  }, [userProfile, processingPaymentState]);

  return (
    <React.Fragment>
      <RouterProvider router={router} />
    </React.Fragment>
  )
}